// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v2.1.1-5-g4901627-dirty",
    "hash": "g4901627",
    "distance": 5,
    "tag": "v2.1.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.1.1",
        "major": 2,
        "minor": 1,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "2.1.1"
    },
    "suffix": "5-g4901627-dirty",
    "semverString": "2.1.1+5.g4901627",
    "version": "0.0.1"
};
/* tslint:enable */
